<template>
  <div>
    <van-tabs v-model="active" sticky>
      <van-tab
        v-for="item in select"
        :title="item.name"
        :key="item.id"
      ></van-tab>
    </van-tabs>

    <div v-if="active == 0" style="height: 100%">
      <div style="300px;">
        <van-list
          :finished="finished"
          finished-text="没有更多了"
          :immediate-check="istrue"
          @load="onLoad"
        >
          <van-swipe-cell v-for="msg in msgs" :key="msg.id">
            <div class="box" @click.stop="toAllbox(msg)">
              <div class="box-title">
                <div>
                  <span class="box-title-order">订单号</span>
                  <span class="box-title-num">{{ msg.orderid }}</span>
                </div>
                <span class="box-title-status">{{ msg.status }}</span>
              </div>
              <div class="box-content">
                <span class="box-content-title">{{ msg.title }}</span>
                <div class="box-content-order">
                  <div class="box-content-timer">{{ getCategoryName(msg) }}</div>
                  <div class="box-content-timer">
                    时间：
                    <span>{{ msg.created_at }}</span>
                  </div>
                </div>
              </div>
              <div class="box-bottom">
                <div class="box-bottom-price-wrap">
                  <span class="box-delete-icon" @click.stop="toDelete(msg)">删除</span>
                  <span class="box-bottom-price">￥{{ msg.price }}</span>
                </div>
                <div v-if="msg.status == '待支付'">
                  <div class="paystyle" @click.stop="toPay(msg)">去支付</div>
                </div>
                <div v-if="msg.status == '检测完成'">
                  <div class="reportstyle" @click.stop="toResult(msg)">查看报告</div>
                </div>
              </div>
            </div>
            <template #right>
              <van-button
                square
                text="删除"
                type="danger"
                class="delete-button"
                @click="toDelete(msg)"
              />
            </template>
          </van-swipe-cell>
        </van-list>
      </div>
    </div>
    <div v-if="active == 1" style="background: #f0f1f5">
      <div
        class="box"
        v-for="msg in complete"
        :key="msg.id"
        @click.stop="toAllbox(msg)"
      >
        <div class="box-title">
          <div>
            <span class="box-title-order">订单号</span>
            <span class="box-title-num">{{ msg.orderid }}</span>
          </div>
          <span class="box-title-status">{{ msg.status }}</span>
        </div>
        <div class="box-content">
            <span class="box-content-title">{{ msg.title }}</span>
            <div class="box-content-order">
              <div class="box-content-timer">{{ getCategoryName(msg) }}</div>
              <div class="box-content-timer">
                时间：
                <span>{{ msg.created_at }}</span>
              </div>
          </div>
        </div>
        <div class="box-bottom">
          <div class="box-bottom-price-wrap">
            <span class="box-delete-icon" @click.stop="toDelete(msg)">删除</span>
            <span class="box-bottom-price">￥{{ msg.price }}</span>
          </div>
          <div v-if="msg.status == '待支付'">
            <div class="paystyle" @click.stop="toPay(msg)">去支付</div>
          </div>
          <div v-if="msg.status == '检测完成'">
            <div class="reportstyle" @click.stop="toResult(msg)">查看报告</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active == 2" style="background: #f0f1f5">
      <div
        class="box"
        v-for="msg in payoff"
        :key="msg.id"
        @click.stop="toAllbox(msg)"
      >
        <div class="box-title">
          <div>
            <span class="box-title-order">订单号</span>
            <span class="box-title-num">{{ msg.orderid }}</span>
          </div>
          <span class="box-title-status">{{ msg.status }}</span>
        </div>
        <div class="box-content">
            <span class="box-content-title">{{ msg.title }}</span>
            <div class="box-content-order">
              <div class="box-content-timer">{{ getCategoryName(msg) }}</div>
              <div class="box-content-timer">
                时间：
                <span>{{ msg.created_at }}</span>
              </div>
          </div>
        </div>
        <div class="box-bottom">
          <div class="box-bottom-price-wrap">
            <span class="box-delete-icon" @click.stop="toDelete(msg)">删除</span>
            <span class="box-bottom-price">￥{{ msg.price }}</span>
          </div>
          <div v-if="msg.status == '待支付'">
            <div class="paystyle" @click.stop="toPay(msg)">去支付</div>
          </div>
          <div v-if="msg.status == '检测完成'">
            <div class="reportstyle" @click.stop="toResult(msg)">查看报告</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="active == 3" style="background: #f0f1f5">
      <div class="box" v-for="msg in other" :key="msg.id">
        <div class="box-title">
          <div>
            <span class="box-title-order">订单号</span>
            <span class="box-title-num">{{ msg.orderid }}</span>
          </div>
          <span class="box-title-status">{{ msg.status }}</span>
        </div>
        <div class="box-content">
            <span class="box-content-title">{{ msg.title }}</span>
            <div class="box-content-order">
              <div class="box-content-timer">{{ getCategoryName(msg) }}</div>
              <div class="box-content-timer">
                时间：
                <span>{{ msg.created_at }}</span>
              </div>
          </div>
        </div>
        <div class="box-bottom">
          <div class="box-bottom-price-wrap">
            <span class="box-delete-icon" @click.stop="toDelete(msg)">删除</span>
            <span class="box-bottom-price">￥{{ msg.price }}</span>
          </div>
          <div v-if="msg.status == '待支付'">
            <div class="paystyle" @click.stop="toPay(msg)">去支付</div>
          </div>
          <div v-if="msg.status == '检测完成'">
            <div class="reportstyle" @click.stop="toResult(msg)">查看报告</div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="show" @click="show = true">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="block-container">
            <p>微信“搜一搜”【万方论文检测】</p>
            <p>关注公众号可收到检测结果</p>
            <p>通知，方便随时查看报告。</p>
            <div
              style="
                display: flex;
                justify-content: center;
                margin-top: 0.33rem;
              "
            >
              <span
                style="
                  background: #0498fa;
                  color: #fff;
                  padding: 0.05rem 0.37rem;
                "
                @click="closeshow"
                >关闭</span
              >
            </div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from "vant";
import { Dialog } from "vant";
import { Overlay } from "vant";
export default {
  data() {
    return {
      msgs: [],
      istrue: false,
      active: "",
      isToken: false,
      show: false,
      finished: false,
      currentpage: 1,
      last_page: "",
      select: [
        {
          id: 1,
          name: "全部",
        },
        {
          id: 2,
          name: "已完成",
        },
        {
          id: 3,
          name: "待付款",
        },
        {
          id: 4,
          name: "其他",
        },
      ],
    };
  },
created() {
  if (window.sessionStorage.getItem("Token")) {
    this.isToken = true;
    const hj = window.navigator.userAgent.toLowerCase();
    const isTrueWX = hj.match(/MicroMessenger/i) == "micromessenger";
    if (!window.sessionStorage.getItem("show") && !isTrueWX) {
      this.show = true;
      window.sessionStorage.setItem("show", "true");
    }
    this.initData();
  } else {
    this.isToken = false;
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      this.$router.push({
        path: "/blankpage",
        query: {
          currentpath: "/report",
        },
      });
    } else {
      // 自定义弹窗
      Dialog({
        title: "",
        message: `<div style="text-align: center; position: relative; max-height: 80vh; overflow: hidden; white-space: normal;"><div id="closeDialogBtn" style="position: absolute; top: 0px; right: 0px; cursor: pointer; font-size: 20px; color: #999; width: 26px; height: 26px; display: flex; align-items: center; justify-content: center; z-index: 10;">×</div><div style="margin-bottom: 12px;"><img src="${require("../../assets/img/logo.jpg")}" alt="Logo" style="width: 100px; height: 100px; border-radius: 50%; object-fit: cover; border: 2px solid #f0f0f0;"></div><div style="margin-bottom: 18px; font-size: 16px; line-height: 1.5; color: #333; text-align: left;">因浏览器限制,无法查看论文检测进度;<br>为方便查收检测报告,请在微信小程序内提交。</div><div style="display: flex; flex-direction: column; gap: 10px; align-items: center;"><button id="openMiniProgramBtn" style="width: 200px; height: 40px; background: #07c160; color: white; border: none; border-radius: 20px; font-size: 16px; cursor: pointer; box-shadow: 0 2px 6px rgba(7, 193, 96, 0.3);">打开微信小程序</button><button id="continueLoginBtn" style="width: 200px; height: 40px; background: #eee; color: #999; border: 1px solid #ddd; border-radius: 20px; font-size: 16px; cursor: pointer;">继续网页登录</button></div></div>`,
        width: "85%",
        allowHtml: true,
        showConfirmButton: false,
        showCancelButton: false,
        closeOnClickOverlay: true,
      });

      // 绑定按钮事件
      setTimeout(() => {
        // 关闭按钮
        const closeBtn = document.getElementById('closeDialogBtn');
        if (closeBtn) {
          closeBtn.onclick = () => {
            Dialog.close();
          };
        }

        // 打开小程序按钮
        const openBtn = document.getElementById('openMiniProgramBtn');
        if (openBtn) {
          openBtn.onclick = () => {
            try {
              window.location.href = "weixin://dl/business/?appid=wx346def384ee887a2&path=pages/index/index&query=wxfrom=baidu";
              Dialog.close();
            } catch (error) {
              console.log("无法打开微信小程序:", error);
              Dialog.close();
              Dialog.alert({
                title: "提示",
                message: "请在微信搜一搜'万方论文检测'使用小程序"
              });
            }
          };
        }

        // 继续登录按钮
        const loginBtn = document.getElementById('continueLoginBtn');
        if (loginBtn) {
          loginBtn.onclick = () => {
            Dialog.close();
            this.$router.push("/Login");
          };
        }
      }, 100);
    }
  }
},
  computed: {
    complete() {
      return this.msgs.filter((item) => {
        return item.status == "检测完成";
      });
    },
    payoff() {
      return this.msgs.filter((item) => {
        return item.status == "待支付";
      });
    },
    other() {
      return this.msgs.filter((item) => {
        return item.status !== "待支付" && item.status !== "检测完成";
      });
    },
  },
  methods: {
    logFrontendEvent(event, payload = {}) {
      if (!this.$http || !this.$http.postFrontendLog) {
        return;
      }

      this.$http.postFrontendLog({
        channel: "h5",
        page: "/report",
        event,
        order_id: payload.order_id || "",
        order_no: payload.order_no || "",
        status: payload.status || "",
        user_agent: window.navigator.userAgent,
        meta: payload.meta || {},
      }).catch(() => {});
    },
    getCategoryName(msg) {
      return (msg && msg.category && msg.category.name) || "检测订单";
    },
    toAllbox(data) {
      if (data.status == "检测完成") {
        this.toResult(data);
        return;
      }
      if (data.status == "待支付") {
        this.toPay(data);
        return;
      }
      if (data.status == "暂停") {
        Toast("该订单被设置暂停检测，请联系客服处理");
        return;
      }
      if (data.status == "检测中" || data.status == "排队中") {
        Toast("该论文正在检测中，如长时间未出结果，请联系客服处理");
        return;
      }
    },
    initData() {
      this.$http.getReport(this.currentpage).then((res) => {
        this.msgs = [...this.msgs, ...res.data];
        this.last_page = res.meta.last_page;
      });
    },
    onLoad() {
      console.log("fsadhf");
      if (this.currentpage < this.last_page) {
        this.currentpage++;
        this.initData();
        return;
      } else {
        this.finished = true;
      }
    },
    canDeleteOrder(order) {
      return order && (order.status == "待支付" || order.status == "检测完成");
    },
    toDelete(order) {
      if (!this.canDeleteOrder(order)) {
        Toast("检测中的订单不可删除");
        return;
      }

      Dialog.confirm({
        message: "你确认要删除吗",
      })
        .then(() => {
          this.$http.deleteOrder(order.id).then((res) => {
            Toast(res.message);
            this.finished = false;
          });

          this.currentpage = 1;
          this.msgs = [];
          this.initData();
        })
        .catch(() => {});
    },
    closeshow() {
      this.show = false;
    },
    //判断当前环境
    toPay(payMsg) {
      this.logFrontendEvent("report_click_pay", {
        order_id: payMsg.id,
        order_no: payMsg.orderid,
        status: payMsg.status,
        meta: {
          from_tab: this.active,
          price: payMsg.price,
        },
      });

      this.$router.push({
        path: "/pay",
        query: {
          id: payMsg.id,
          title: payMsg.title,
          writer: payMsg.writer,
          words: payMsg.words,
          price: payMsg.price,
          orderid: payMsg.orderid,
          name: this.getCategoryName(payMsg),
          timer: payMsg.created_at,
        },
      });
    },
    toResult(msg) {
      let api_orderid = msg.api_orderid;
      let id = msg.id;
      let orderid = msg.orderid;
      let title = msg.title;
      let writer = msg.writer;
      let timer = msg.rate;
      let report_pdf_path = msg.report_pdf_path;
      let report = msg.report;
      let date_pay = msg.date_pay;
      let bbname = msg.category.name;
      this.$router.push({
        path: "/result",
        query: {
          id: msg.id,
          title: msg.title,
          writer: msg.writer,
          timer: msg.rate,
          orderid: msg.orderid,
          report_pdf_path: msg.report_pdf_path,
          report: report,
          date_pay: msg.date_pay,
          bbname: this.getCategoryName(msg),
          api_orderid: api_orderid,
          cid: msg.cid,
        },
      });
    },
  },
};
</script>

<style scoped>
.box {
  background: #fff;
  margin-top: 0.2rem;
  padding: 0.2rem;
  box-sizing: border-box;
}
.box-title {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  padding: 0.1rem 0;
  font-size: 0.3rem;
}
.box-title-num {
  color: #0498fa;
  margin-left: 0.1rem;
}
.box-title-order {
  color: #ababab;
}
.box-title-status {
  color: #ee0000;
}
.box-content {
  padding: 0.2rem 0;
  border-bottom: 1px solid #ccc;
}
.box-content-order {
  display: flex;
  justify-content: space-between;
}
.box-bottom {
  font-size: 0.31rem;
  display: flex;
  align-items: center;
  padding-top: 0.15rem;
  justify-content: space-between;
}
.box-bottom-price-wrap {
  display: flex;
  align-items: center;
  gap: 0.14rem;
}
.box-title-num {
  color: #0498fa;
  margin-left: 10rpx;
}
.box-bottom-price {
  color: #ee0000;
}
.box-delete-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0.78rem;
  height: 0.42rem;
  padding: 0 0.14rem;
  border-radius: 999px;
  background: #eef2f7;
  color: #64748b;
  font-size: 0.22rem;
  font-weight: 600;
}
.box-content-title {
  font-size: 0.3rem;
  font-weight: bold;
  margin-bottom: 0.1rem;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.box-content-timer {
  font-size: 0.3rem;
}
.paystyle {
  background-color: #0498fa;
  color: #fff;
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 0.1rem;
  font-size: 0.3rem;
  padding: 0 0.3rem;
}
.reportstyle {
  background-color: #9acd32;
  color: #fff;
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 0.1rem;
  font-size: 0.3rem;
  padding: 0 0.3rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  background-color: #fff;
  width: 5.5rem;
  height: 4.3rem;
  display: flex;
  border: 1px solid #ccc;
  justify-content: center;
  align-items: center;
}
.block-container {
  font-size: 0.33rem;
  line-height: 0.5rem;
}
.delete-button {
  height: 100%;
}
</style>
